export default {
	search: 'Press Enter to Search for Themes',
	use: 'Use Theme',
	used: 'Already using Theme',
};
